import { useTranslation } from 'react-i18next';

const useAppLanguage = (): string => {
  const { i18n } = useTranslation();

  return i18n.language.toUpperCase();
};

export default useAppLanguage;
